module.exports = __webpack_public_path__ + "img/login-auth.9f50342a.png";